module.exports = __webpack_public_path__ + "static/media/flexip.37371b41.svg";